export const RESOURCE_TYPES = {
  TEST: 'test',
  BRAND: 'brand',
  USER: 'user'
}

export const ROLES = {
  ADMIN: 'admin'
}
